import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./EditTocPage.css";
import { loadATitleRequestAction } from "../../redux/actions/appTitles";
import { loadAnIssueRequestAction } from "../../redux/actions/appIssues";
import PdfEditTocContainer from "../../components/PdfEditTocContainer/PdfEditTocContainer";
import WebEditTocContainer from "../../components/WebEditTocContainer/WebEditTocContainer";
import Badge from "react-bootstrap/Badge";

class EditTocPage extends React.Component {
  componentDidMount() {
    const { match, history } = this.props;

    if (this.props.titleName == null) {
      this.props.loadATitleRequestAction(match.params.titleID, toast, history);
    }

    if (this.props.issueName == null) {
      this.loadIssue();
    }
  }

  loadIssue() {
    const { match, history, loadAnIssueRequestAction } = this.props;
    loadAnIssueRequestAction(
      match.params.issueID,
      match.params.bookType === "pdf_books",
      toast,
      history
    );
  }

  renderSwitch() {
    const { title, issue, match } = this.props;
    const isPdf = match.params.bookType === "pdf_books";

    if (isPdf) {
      return <PdfEditTocContainer title={title} issue={issue} />;
    } else {
      return <WebEditTocContainer title={title} issue={issue} />;
    }
  }

  render() {
    const { match, issue, title, zoomed } = this.props;

    const meTitleLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/pdf_books`;
    const titleName = title != null ? title.name : "";
    const titleAutomate = title != null ? title.automate : 0;

    const meLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/${match.params.bookType}/${match.params.issueID}`;
    const issueName = issue != null ? issue.issue : "";

    return (
      <Container
        className="edit_toc_page"
        style={
          zoomed
            ? { maxWidth: "2048px", width: "2048px", paddingRight: "350px" }
            : {
                minWidth: "400px",
                maxWidth: "calc(100% - 300px)",
                width: "calc(100% - 300px)"
              }
        }
      >
        <Row>
          <Col>
            <Breadcrumb active="true" className="path_container">
              <Breadcrumb.Item href={process.env.REACT_APP_URL_ROOT}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item href={meTitleLink}>
                {titleName}
                {titleAutomate >= 1 && (
                  <Badge
                    variant="warning"
                    className="title_list_item_auto_badge"
                  >
                    {titleAutomate >= 2 ? "Fit Reading" : "TOC"}
                  </Badge>
                )}
              </Breadcrumb.Item>
              <Breadcrumb.Item href={meLink}>{issueName}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row>
          <Col>{this.renderSwitch()}</Col>
        </Row>
      </Container>
    );
  }
}

const mapState = (state, ownProps) => {
  const { appTitles, appIssues, pdfEditTocContainer } = state;
  const { match } = ownProps;

  return {
    title: appTitles[match.params.titleID],
    issue: appIssues[match.params.issueID],
    zoomed: pdfEditTocContainer.zoomed
  };
};

const mapDispatch = {
  loadATitleRequestAction,
  loadAnIssueRequestAction
};

export default connect(
  mapState,
  mapDispatch
)(withRouter(EditTocPage));
